/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                /* genral code that can be kept across manny projects */
                // fix console.log bug on IE8
                if (typeof console === "undefined") {
                    console = {
                        log: function() {}
                    };
                }
                //end fix console.log bug on IE8                
                // display none the helper that tells you what template is being loaded into the page
                $("body > p:contains('Rendered template:')").css("display", "none");

                // make viewport better on small screens
                if (screen.width <= 480) {
                    $("meta[name='viewport']").attr("content", "initial-scale=0.6");
                }
                // make plain text email address less likely to be spamed.
                $(".less_spam_email").each(function() {
                    var ats, dots, address, i;
                    ats = [' at ', ' (at) ', ' [at] '];
                    dots = [' dot ', ' (dot) ', ' [dot] ', ' [dot] '];
                    address = $(this).html();
                    for (i = 0; i < ats.length; i++) {
                        address = address.replace(ats[i], '@');
                    }
                    for (i = 0; i < dots.length; i++) {
                        address = address.replace(dots[i], '.');
                    }
                    $(this).html('<a href="mailto:' + address + '">' + address + '</a>');
                });
                // Code for fixing example.dev:3000 issue. 
                // $("a").on("click", function() {
                //     var currentURL = $(this).attr("href");
                //     if (currentURL.toLowerCase().indexOf("wp-admin") > -1 || currentURL.toLowerCase().indexOf("logout") > -1 || currentURL.toLowerCase().indexOf("wp-content") > -1) {
                //         // if user clicks dashboard links from front end remove the port so it will not redirect to the dash with the 3000
                //         currentURL = currentURL.replace(":3000", "");
                //         window.location.href = currentURL;
                //         return false;
                //     } else if (currentURL.toLowerCase().indexOf("example.dev") > -1 && currentURL.toLowerCase().indexOf(":3000") < 0) {
                //         // if on example.dev and is frontend (not admin page) and the port is not already set then add the port
                //         currentURL = currentURL.replace(document.location.hostname, document.location.hostname + ":3000");
                //         window.location.href = currentURL;
                //         return false;
                //     }
                // });

                $(".expandable-area").click(function() {
                    console.log("Clicked");
                    $(this).find(".toggle-area").slideToggle("slow", function() {
                        // Animation complete.
                    });
                });

                $('#sticky-sidebar').Stickyfill();

                ////////////////////////////////
                //ACF
                ////////////////////////////////
                //ACF fill title field
                //used when a form is being filled on the front end. e.g testimonial...
                //It inserts a secondery field into the post title field and hides post title
                $("#acf-field_54ee353e2cace").keyup(function(event) {
                    var val = "";
                    val = $(this).val();
                    $("#acf-_post_title").val(val);
                });
                $("#acf-_post_title").parent().parent().parent().hide();
                //ACF change post updated text
                //Remove title and show updated text on submit.               
                if ($("div#message.updated p:contains('Post updated')").length) {
                    $("div#message.updated p").text("Thank you for your feedback");
                    $("#submit_your_feedback").hide();
                }

                // custom acf validation errors alerts
                if (typeof acf !== 'undefined') {

                    acf.add_filter('validation_complete', function(json, $form) {
                        //http://www.advancedcustomfields.com/resources/adding-custom-javascript-fields/
                        // if errors?
                        if (json.errors) {
                            //console.log(json.errors);
                            if ($("body").hasClass("single-companies")) {
                                alert("The form has not been fully completed. Please check the form for red errors and correct them. If you have added an address make sure to use the test address button.");
                            } else {
                                alert("The form has not been fully completed. Please check the form for red errors and correct them.");
                            }
                            // remove spinner on modal window
                            $(".acf-spinner").removeClass("is-active");
                        }
                        // return 
                        return json;
                    });
                }

                ////////////////////////////////
                //WOOCOMMERCE
                ////////////////////////////////

                //woocommerce fix for course cols
                /*                $(".courses60").wrapAll("<div class='col-xs-12 col-sm-12 col-md-7 col-lg-7' />");
                                $(".courses40").wrapAll("<div class='col-xs-12 col-sm-12 col-md-5 col-lg-5' />");
                                // end woocommerce fix for course cols
                                $(document).on({
                                    mouseenter: function() {
                                        $(".show_minicart").stop().slideToggle();
                                    },
                                    mouseleave: function() {

                                        $(".show_minicart").stop().slideToggle();

                                    }
                                }, ".hover_me_to_show_minicart"); //pass the element as an argument to .on*/

                // BOOTSTRAP DROPDOWNS

                // mobile collapse 

                // set up clickToggle              
                (function($) {
                    $.fn.clickToggle = function(func1, func2) {
                        var funcs = [func1, func2];
                        this.data('toggleclicked', 0);
                        this.click(function() {
                            var data = $(this).data();
                            var tc = data.toggleclicked;
                            $.proxy(funcs[tc], this)();
                            data.toggleclicked = (tc + 1) % 2;
                        });
                        return this;
                    };
                }(jQuery));

                $('button[class="navbar-toggle"]').clickToggle(function() {
                    var data_target = $(this).attr("data-target");
                    $(data_target).addClass("show_important");
                }, function() {
                    data_target = $(this).attr("data-target");
                    $(data_target).removeClass("show_important");
                });


                // make bootstrap multi dropdowns work              
                // make caret go back how it was when clicking outside of the nav menu
                $('html').click(function() {
                    $(".caret").css({
                        "border-bottom": "0px solid",
                        "border-top": "4px solid"
                    });
                });
                $('nav[data-role="navigation"]').click(function(event) {
                    event.stopPropagation();
                });

                // add the dropdown classes that get missed out in the php loop
                $(".dropdown > a:not(.dropdown-toggle)")
                    .attr("dropdown-toggle", "dropdown")
                    .addClass("dropdown-toggle")
                    .append('<b class="caret"></b>');

                // what to do on click to open and close the extra dropdowns
                $(".dropdown > a").click(function() {
                    if ($(this).parent().hasClass("open")) {
                        $(this).parent().parent().find(".open").removeClass("open");
                        $(this).parent().parent().find(".caret").css({
                            "border-bottom": "0px solid",
                            "border-top": "4px solid"
                        });
                    } else {
                        $(this).parent().parent().find(".open").removeClass("open");
                        $(this).parent().addClass("open");
                        $(this).find(".caret").css({
                            "border-bottom": "4px solid",
                            "border-top": "0px solid"
                        });
                    }

                    // dont action the page load...
                    return false;
                });

                // make footer go to the bottom of page...
                var last_run_height = 0,
                    wordpress_admin_bar;
                if ($('#wpadminbar').length !== 0) {
                    wordpress_admin_bar = 32;
                } else {
                    wordpress_admin_bar = 0;
                }

                function doFooter() {
                    var window_height = window.innerHeight,
                        footer_elem = $("footer[data-role='contentinfo']"),
                        margin_push = 0,
                        overall_height = $("body").outerHeight(true),
                        current_margin = parseInt($(footer_elem).css("marginTop").replace('px', ''), 10),
                        overall_height_minus_margin = overall_height - current_margin;

                    if (last_run_height !== 0 && last_run_height <= overall_height) {
                        if (overall_height_minus_margin < window_height) {
                            $("footer[data-role='contentinfo']").css("margin-top", "0px");
                        }
                        if (overall_height_minus_margin < window_height) {
                            margin_push = window_height - overall_height_minus_margin;
                            $("footer[data-role='contentinfo']").css("margin-top", Math.round(margin_push - wordpress_admin_bar) + "px");
                        }
                    } else {
                        if (overall_height_minus_margin < window_height) {
                            margin_push = window_height - overall_height_minus_margin;
                            $("footer[data-role='contentinfo']").css("margin-top", Math.round(margin_push - wordpress_admin_bar) + "px");
                        }
                    }
                    last_run_height = overall_height;
                }
                $(window).load(function() {
                    doFooter();
                    new ResizeSensor($("body"), function() { //http://marcj.github.io/css-element-queries/
                        doFooter();
                    });
                });
                // end make footer go to the bottom of page...
                // header login
                function animateRotate(d, q) {
                    var elem = $(q);

                    $({
                        deg: 0
                    }).animate({
                        deg: d
                    }, {
                        duration: 300,
                        step: function(now) {
                            elem.css({
                                transform: "rotate(" + now + "deg)"
                            });
                        }
                    });
                }

                function fixRotate(d, q) {
                    var elem = $(q);

                    $({
                        deg: 0
                    }).animate({
                        deg: d
                    }, {
                        duration: 0,
                        step: function(now) {
                            elem.css({
                                transform: "rotate(" + now + "deg)"
                            });
                        }
                    });
                }
                var flag_one = true;
                var flag_two = true;
                $(".show_header_login").on("click", function() {
                    if ($(this).is(".show_header_login")) {
                        $("#top_login_form").slideToggle();

                        animateRotate(180, ".spin_me");
                        if (flag_one === false) {
                            setTimeout(function() {
                                animateRotate(0, ".spin_me");
                                $('.show_header_login .spin_me').removeClass('glyphicon-menu-up');
                                $('.show_header_login .spin_me').addClass('glyphicon-menu-down');
                                fixRotate(0, ".show_header_login.spin_me");
                            }, 500);
                            flag_one = true;
                        } else {
                            setTimeout(function() {
                                animateRotate(0, ".spin_me");
                                $('.show_header_login .spin_me').removeClass('glyphicon-menu-down');
                                $('.show_header_login .spin_me').addClass('glyphicon-menu-up');
                            }, 500);
                            flag_one = false;
                        }
                    }
                    if ($(this).is("#edit_page_btn")) {
                        $("#edit_page_area").slideToggle();

                        animateRotate(180, "#edit_page_btn span");
                        if (flag_two === false) {
                            setTimeout(function() {
                                //console.log("first");
                                $('#edit_page_btn span').addClass('glyphicon-menu-down');
                                $('#edit_page_btn span').removeClass('glyphicon-menu-up');

                                fixRotate(0, "#edit_page_btn span");
                            }, 1000);
                            flag_two = true;
                        } else {
                            setTimeout(function() {
                                //console.log("last");
                                $('#edit_page_btn span').removeClass('glyphicon-menu-down');
                                $('#edit_page_btn span').addClass('glyphicon-menu-up');

                                fixRotate(0, "#edit_page_btn span");
                            }, 1000);
                            flag_two = false;
                        }
                    }
                });
                // end header login

                // END ALL
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
